export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-rss-142e23e23fc932eddf9e403882d49682.svg";